export var angleFrom6 = function (angle) {
  return angle + 90;
};